import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { MatDialog} from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { ViewNoteModalComponent } from "../../modals/view-note-modal/view-note-modal.component";
import { HttpResponse } from "@angular/common/http";

@Component({
  selector: "fury-claims-side-menu",
  templateUrl: "./claims-side-menu.component.html",
  styleUrls: ["./claims-side-menu.component.scss"],
})
export class ClaimsSideMenuComponent implements OnInit {
  panelOpenState = false;
  @Input() userData: any;
  @Input() fetchSideMenu: boolean = false;
  claims = null;
  otherInfo = null;
  ngUnsubscribe = new Subject<void>();
  userId = "";
  claimId = "";
  statusLight:any;
  constructor(
    private apiService: ApiService,
    private activateRoute: ActivatedRoute,
    public commonService: CommonService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.userId = this.activateRoute.snapshot.params["id"];
    this.claimId = this.activateRoute.snapshot.params["claimId"];

    if (this.userId) {
      this.getUserData();
    }

    if (this.claimId) {
      this.getFileClaimLeftPanelDetail();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.fetchSideMenu && changes?.fetchSideMenu.currentValue === true) {
      this.getUserData();
      this.getFileClaimLeftPanelDetail();
    }
  }

  getUserData() {
    this.apiService
      .get(endpoints.customerDashboard.getUser(this.userId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res.body) {
          this.userData = res?.body?.user;
          this.statusLight = res.body?.statusLight
        }
      });
  }

  getFileClaimLeftPanelDetail() {
    this.apiService
      .get(
        endpoints.customerDashboard.getFileClaimLeftPanelDetail(this.claimId)
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          this.claims = res?.body?.claim;
          this.otherInfo = res?.body?.otherInfo;
        }
      });
  }

  openViewModal(rowData: any, type: string) {
    let dialogRef = this.dialog.open(ViewNoteModalComponent, {
      width: "600px",
      panelClass: "payment-info",
      data: {
        type, rowData
      }
    });
  }
}
